import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import { Nav, NavItem, NavLink } from "reactstrap";
import classnames from "classnames";

const PrimeAatbHeader = (props) => {
    const { activeTab, toggle, mmbrAatbList } = props;

    const pedcCd = useSelector((state) => state.loginReducer.pedcCd);

    const [aatbList, setAatbList] = useState({
        ENGM: "미설정",
        MATH: "미설정",
    });

    const subjectName = (code) => {
        const subjectName = {
            "PEDC-00015": "영어",
            "PEDC-00016": "수학",
        };
        return subjectName[code];
    };
    const subjectCode = (code) => {
        const subjectCode = {
            "PEDC-00015": "ENGM",
            "PEDC-00016": "MATH",
        };
        return subjectCode[code];
    };
    const subjectClassName = (code) => {
        const subjectClassName = {
            "PEDC-00015": "english",
            "PEDC-00016": "math",
        };
        return subjectClassName[code];
    };

    useEffect(() => {
        if (mmbrAatbList.length > 0 && Boolean(mmbrAatbList[0].COURSE_GRP_CD)) {
            const math = mmbrAatbList.filter((value) => value.COURSE_GRP_CD === "MATH");
            const engm = mmbrAatbList.filter((value) => value.COURSE_GRP_CD === "ENGM");

            setAatbList({
                ...aatbList,
                MATH:
                    math.length > 0 && Boolean(math[0].PBCM_NAME)
                        ? math[0].PBCM_NAME + ((math[0].AUTR_YN || "") === "Y" ? "(" + math[0].AUTR_NAME + ")" : "")
                        : "미설정",
                ENGM:
                    engm.length > 0 && Boolean(engm[0].PBCM_NAME)
                        ? engm[0].PBCM_NAME + ((engm[0].AUTR_YN || "") === "Y" ? "(" + engm[0].AUTR_NAME + ")" : "")
                        : "미설정",
            });
        }
    }, [mmbrAatbList]);

    return (
        <Nav tabs className="textbookTab">
            <NavItem className={classnames({ active: activeTab === "1" })}>
                <NavLink
                    className={(classnames({ active: activeTab === "1" }), subjectClassName(pedcCd))}
                    // onClick={() => {
                    //     toggle("1");
                    // }}
                >
                    {subjectName(pedcCd)}
                    <span>{aatbList[subjectCode(pedcCd)]}</span>
                </NavLink>
            </NavItem>
        </Nav>
    );
};

export default PrimeAatbHeader;
